import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MatchSpecificationOutput from "./MatchSpecificationOutput";

interface MatchSpecificationVehicleProps {
    vehicleId: string;
    specification: object | null | string;
    onSpecificationChange?: (spec: object) => void;
}

const MatchSpecificationVehicle = (props: MatchSpecificationVehicleProps) => {
    const navigate = useNavigate();
    const [result, setResult] = useState<object | null | string>({});

    useEffect(() => {
        setResult(props.specification);
    }, [props.specification]);

    const handleResultChange = (spec: object) => {
        setResult(spec);
        props.onSpecificationChange?.(spec);
    };

    const hasSpec = result && typeof result === "object" && Object.keys(result).length > 0;

    return (
        <div className="my-4">
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => navigate(`/match-specification/${props.vehicleId}`)}
                >
                    <i className="bi bi-cpu me-2" />
                    Match Specification
                </button>
            </div>

            {hasSpec ? (
                <MatchSpecificationOutput
                    result={result}
                    vehicleId={props.vehicleId}
                    loading={false}
                    readOnly
                    onResultChange={handleResultChange}
                />
            ) : (
                <div style={{ padding: "48px 0", textAlign: "center", color: "#9ca3af" }}>
                    <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
                    <p style={{ fontSize: 15, fontWeight: 500, color: "#6b7280" }}>
                        No specification available
                    </p>
                    <p style={{ fontSize: 13, marginBottom: 20 }}>
                        Click "Match Specification" to extract specs from a raw document.
                    </p>
                </div>
            )}
        </div>
    );
};

export default MatchSpecificationVehicle;
